import { render, staticRenderFns } from "./WelfareCentreOperation.vue?vue&type=template&id=5a2953ea&scoped=true&"
import script from "./WelfareCentreOperation.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2953ea",
  null
  
)

export default component.exports